export default "__VITE_ASSET__CCXZFWw3__"